module.exports = __webpack_public_path__ + "static/media/hira-home.b60d6353.jpg";